// extracted by mini-css-extract-plugin
module.exports = {"select":"select_select__2waes","dropdown":"select_dropdown__3f1We"};